/* eslint-disable indent */
class SideTabs {
	constructor(el) {
		this.el = el;
		this.tabs = this.el.querySelectorAll('.block-side-tabs__tab');
		this.tabContentContainer = this.el.querySelectorAll('.block-side-tabs__tab-content-container');
		this.tabContent = this.el.querySelectorAll('.block-side-tabs__tab-content');
		this.tabContentTitle = this.el.querySelectorAll('.block-side-tabs__tab-content-title');

		this.handleTabClick();
		this.handleAccordionClick();

		window.addEventListener('resize', () => {
			this.handleTabClick();
			this.handleAccordionClick();
		});
		
	}

    handleTabClick = () => {
		if (window.innerWidth >= 768) {
			this.tabs.forEach((tab) => {
				tab.addEventListener('click', () => {
					this.tabContentContainer.forEach((tabContent) => {
						if (tabContent.dataset.index === tab.dataset.index) {
							tabContent.classList.add('active');
						} else {
							tabContent.classList.remove('active');
						}
					});
					this.tabs.forEach((t) => {
						if (t.dataset.index !== tab.dataset.index) {
							t.classList.remove('active');
						} else {
							t.classList.add('active');
						}
					})
				});
			})
	
		}
    }

	handleAccordionClick = () => {
		if (window.innerWidth < 768) {
			this.tabContentContainer.forEach((tabContent) => {
				const title = tabContent.querySelector('.block-side-tabs__tab-content-title');
				title.addEventListener('click', () => {
					if (tabContent.classList.contains('active')) {
						tabContent.classList.remove('active');
					} else {
						this.tabContentContainer.forEach((c) => {
							if (c.dataset.index !== title.dataset.index) {
								c.classList.remove('active');
							} else {
								c.classList.add('active');
							}
						})
					}
				})
			})
		}

	}
    
}

export default SideTabs;